import Create from "./Create";
import Search from "./Search";
import Filter from "./Filter";
import Body from "./Body";
import ShowInfoTicket from "./ShowTicket";

const Components = {
  Create,
  Search,
  Filter,
  Body,
  ShowInfoTicket,
};

export default Components;
